import { AnimatePresence, motion } from "framer-motion";
import { useState } from "react";
import { Link } from "react-router";
import { cn } from "../../../lib/utils";
import CBSGCharLoader from "../../Page/CBSGCharLoader";

export const HoverEffect = ({ items, className }) => {
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [imgLoaded, setImgLoaded] = useState(false);
  return (
    <div
     className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 grid-auto-flow-col gap-4 mb-10 justify-items-center"
    >
      {items.map((item, idx) => (
        <Link
          to={`/Services/Organization-Development/${item.id}`}
          key={item.id}
          className="relative group block p-2 h-full w-full min-w-[28rem] max-w-[35rem]"
          onMouseEnter={() => setHoveredIndex(idx)}
          onMouseLeave={() => setHoveredIndex(null)}
          
        >
          <AnimatePresence>
            {hoveredIndex === idx && (
              <motion.span
                className="absolute inset-0 h-full w-full z-10 rounded-lg bg-gray-100 block "
                layoutId="hoverBackground"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1, transition: { duration: 0.15 } }}
                exit={{
                  opacity: 0,
                  transition: { duration: 0.15, delay: 0.2 },
                }}
              />
            )}
          </AnimatePresence>
          <Card>
            <div className="flex gap-5 h-full ">
              <div className="relative">
                {item.images && (
                  <div className="max-h-[10rem]">
                    {!imgLoaded && <CBSGCharLoader />}
                    <img
                      src={item.images}
                      alt={item.name}
                      onLoad={() => setImgLoaded(true)}
                      className={`w-40 h-40 min-w-24 max-w-40 object-cover transition-opacity duration-500 ${
                        imgLoaded ? "opacity-100" : "opacity-0"
                      }`}
                    />
                  </div>
                )}
              </div>

              <div className="max-w-[20rem]">
                {" "}
                <CardTitle>{item.name}</CardTitle>
                <CardDescription>
                { item.description }
                </CardDescription>
              </div>
            </div>
          </Card>
        </Link>
      ))}
    </div>
  );
};

export const Card = ({ className, children }) => {
  return (
    <div
      className={cn(
        "h-full w-full p-4 overflow-hidden shadow-lg rounded-lg bg-white  border border-gray-300 z-50",
        className
      )}
    >
      <div className="relative z-20">
        <div className="p-4">{children}</div>
      </div>
    </div>
  );
};

export const CardTitle = ({ className, children }) => {
  return (
    <h4
      className={cn(
        "text-black font-bold text-lg tracking-wide mt-2 border-b border-gray-300",
        className
      )}
    >
      {children}
    </h4>
  );
};

export const CardDescription = ({ className, children }) => {
  return (
    <div
      className={cn(
        "mt-2 text-gray-700 tracking-wide leading-relaxed text-sm",
        className
      )}
    >
      <div
  dangerouslySetInnerHTML={{
    __html:
    children.replace(/<[^>]+>/g, "").length > 120
        ? children.replace(/<[^>]+>/g, "").slice(0, 120) + "..."
        : children.replace(/<[^>]+>/g, "")
  }}
/>
    </div>
  );
};
